import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';
import { darken, lighten } from 'polished';
import { color } from '../../../styles/styles.js';

var colorValue = function colorValue(props) {
  switch (props.fcStyle) {
    case 'danger':
      return color.danger;

    case 'warning':
      return color.warning;

    case 'info':
      return color.info;

    case 'success':
      return color.success;

    default:
      return props.buttonColor || color.primary;
  }
};

var primaryColorValue = function primaryColorValue(props) {
  switch (props.fcStyle) {
    case 'danger':
      return color.dangerButton;

    case 'warning':
      return color.warningButton;

    case 'info':
      return color.infoButton;

    case 'success':
      return color.successButton;

    default:
      return props.buttonColor || color.primaryButton;
  }
};

var primaryColorValueHover = function primaryColorValueHover(props) {
  switch (props.fcStyle) {
    case 'danger':
      return darken(0.1, color.dangerButton);

    case 'warning':
      return darken(0.1, color.warningButton);

    case 'info':
      return darken(0.1, color.infoButton);

    case 'success':
      return darken(0.1, color.successButton);

    default:
      return darken(0.1, props.buttonColor || color.primaryButton);
  }
};

var colorValueDarken = function colorValueDarken(props) {
  switch (props.fcStyle) {
    case 'danger':
      return darken(0.1, color.danger);

    case 'warning':
      return darken(0.1, color.warning);

    case 'info':
      return darken(0.1, color.info);

    case 'success':
      return darken(0.1, color.success);

    default:
      return darken(0.1, props.buttonColor || color.primary);
  }
};

var colorValueLink = function colorValueLink(props) {
  switch (props.fcStyle) {
    case 'danger':
      return props.theme === 'dark' ? lighten(0.2, color.danger) : color.danger;

    case 'warning':
      return props.theme === 'dark' ? color.warning : color.warning;

    case 'info':
      return props.theme === 'dark' ? lighten(0.1, color.info) : darken(0.1, color.info);

    case 'success':
      return props.theme === 'dark' ? lighten(0.1, color.success) : color.success;

    default:
      return props.buttonColor || props.theme === 'dark' ? lighten(0.2, color.primary) : color.primary;
  }
};

var primaryFontColor = function primaryFontColor(props) {
  switch (props.fcStyle) {
    case 'warning':
      return color.warningButtonFont;

    default:
      return '#fff';
  }
};

var StyledIcon = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: rgba(0, 0, 0, 0.2);\n  margin-right: 5px;\n  padding: 5px;\n  font-size: 14px;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  vertical-align: middle;\n  color: #fff;\n  ", "\n"], ["\n  background-color: rgba(0, 0, 0, 0.2);\n  margin-right: 5px;\n  padding: 5px;\n  font-size: 14px;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  vertical-align: middle;\n  color: #fff;\n  ", "\n"])), function (props) {
  return !props.primary && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), colorValue);
});
var StyledButton = styled.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  vertical-align: middle;\n  padding: 0 10px;\n  box-sizing: border-box;\n  height: 34px;\n  cursor: pointer;\n  position:relative;\n  border-radius: 5px;\n  transition: all 0.2s ease;\n  ", "\n    ", "\n\n   ", "\n"], ["\n  vertical-align: middle;\n  padding: 0 10px;\n  box-sizing: border-box;\n  height: 34px;\n  cursor: pointer;\n  position:relative;\n  border-radius: 5px;\n  transition: all 0.2s ease;\n  ", "\n    ", "\n\n   ", "\n"])), function (props) {
  return !props.primary && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: transparent;\n      color: ", ";\n      border: solid 1px ", ";\n      &:hover:not(:disabled) {\n        color: #fff;\n        border-color: ", ";\n        background-color: ", ";\n        transform: scale(1.05);\n      }\n      &:active:not(:disabled) {\n        transform: scale(0.95);\n      }\n      &:disabled {\n        border-color: ", ";\n        color: ", ";\n        transition: none;\n        cursor: not-allowed;\n        ", " {\n          background-color: ", ";\n        }\n      }\n    "], ["\n      background-color: transparent;\n      color: ", ";\n      border: solid 1px ", ";\n      &:hover:not(:disabled) {\n        color: #fff;\n        border-color: ", ";\n        background-color: ", ";\n        transform: scale(1.05);\n      }\n      &:active:not(:disabled) {\n        transform: scale(0.95);\n      }\n      &:disabled {\n        border-color: ", ";\n        color: ", ";\n        transition: none;\n        cursor: not-allowed;\n        ", " {\n          background-color: ", ";\n        }\n      }\n    "])), function (_a) {
    var theme = _a.theme;
    return theme === 'dark' ? color.darkModeLightest : '#000';
  }, colorValue, colorValueDarken, colorValue, color.mediumdark, color.mediumdark, StyledIcon, color.mediumdark);
}, function (props) {
  return props.primary && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        background-color: ", ";\n        border: none;\n        color: ", ";\n        &:hover:not(:disabled) {\n          background-color: ", ";\n          transform: scale(1.05);\n        }\n        &:active:not(:disabled) {\n          transform: scale(0.95);\n        }\n        &:disabled {\n          background-color: ", ";\n          color: ", ";\n          transition: none;\n          cursor: not-allowed;\n        }\n      "], ["\n        background-color: ", ";\n        border: none;\n        color: ", ";\n        &:hover:not(:disabled) {\n          background-color: ", ";\n          transform: scale(1.05);\n        }\n        &:active:not(:disabled) {\n          transform: scale(0.95);\n        }\n        &:disabled {\n          background-color: ", ";\n          color: ", ";\n          transition: none;\n          cursor: not-allowed;\n        }\n      "])), primaryColorValue, primaryFontColor, primaryColorValueHover, color.medium, color.mediumdark);
}, function (props) {
  return props.as === 'a' && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n       border: none;\n       text-decoration: underline;\n       height: fit-content;\n       background-color: transparent;\n       color: ", ";\n       display: inline-block;\n       ", "\n       .button-icon {\n         background-color: ", ";\n         padding: 4px 5px;\n         text-align: center;\n         svg {\n           color: ", ";\n         }\n       }\n       &:hover {\n         background-color: transparent !important;\n         color: ", "!important;\n       }\n     "], ["\n       border: none;\n       text-decoration: underline;\n       height: fit-content;\n       background-color: transparent;\n       color: ", ";\n       display: inline-block;\n       ", "\n       .button-icon {\n         background-color: ", ";\n         padding: 4px 5px;\n         text-align: center;\n         svg {\n           color: ", ";\n         }\n       }\n       &:hover {\n         background-color: transparent !important;\n         color: ", "!important;\n       }\n     "])), colorValueLink, function (props) {
    return !props.icon && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n           padding: 0;\n         "], ["\n           padding: 0;\n         "])));
  }, colorValueLink, props.theme === 'dark' ? color.darkModeDarkest : color.lightest, colorValueLink);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
export { StyledButton, StyledIcon };